import {
  StyledAccordion,
  StyledOverlayDetails,
  OverlayList,
  OverlayItem,
  StyledTooltip,
  Description,
} from './DetailsOfGovernmentOverlays.styled';
import { FunctionComponent } from 'react';
import { Ul, Li, H4 } from '@property.com.au/ui-kit';
import {
  ButtonFromAPIWithClickHandler,
  TextFragment,
  WebLinkFragment,
} from '../../../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';
import { mapDynamicContentItem } from '../../../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';

type OverlayBreakdown = {
  categoryTitle: string;
  overlays: (string | null)[];
  tooltip: string | null;
};

export interface OverlayDetailsType {
  title: string;
  description: (ButtonFromAPIWithClickHandler | TextFragment | WebLinkFragment)[];
  overlayBreakdown: OverlayBreakdown[];
}

export const OverlayDetails: FunctionComponent<OverlayDetailsType> = ({
  title,
  description,
  overlayBreakdown,
}) => {
  return (
    <StyledAccordion headingLevel={3} sizeVariant="small" id="government-overlays-accordion">
      <StyledOverlayDetails title={title} id="government-overlays-details">
        <Description
          dynamicContents={description
            .map(mapDynamicContentItem)
            .filter((contentItem) => contentItem !== null)}
          textColorVariant="textSecondary"
        />
        <OverlayList>
          {overlayBreakdown.map(({ categoryTitle, overlays, tooltip }) => (
            <OverlayItem key={categoryTitle}>
              <H4>
                {categoryTitle}{' '}
                {tooltip && (
                  <StyledTooltip
                    buttonLabel="More information"
                    id={`tooltip-${categoryTitle}`}
                    sizeVariant="small"
                    dangerouslySetClassNames={{
                      triggerButton: 'triggerButton',
                    }}
                  >
                    {tooltip}
                  </StyledTooltip>
                )}
              </H4>
              <Ul>
                {overlays.map((overlayDescription, index) => (
                  <Li key={`${overlayDescription}-${index}`}>{overlayDescription}</Li>
                ))}
              </Ul>
            </OverlayItem>
          ))}
        </OverlayList>
      </StyledOverlayDetails>
    </StyledAccordion>
  );
};
